import { Button } from '../../shared/ui/button';
import { SectionPanel } from '../../shared/ui/section-panel';
import { cn } from '../../shared/lib/cn';
import { relativeTime } from '../../shared/lib/format';
import {
  holdersWords,
  versionHolding,
  versionNote,
  type IPin,
  type TTransform,
  type TTransformVersionSummary,
} from '../../entities/transform';

interface IProps {
  item: TTransform;
  versions: TTransformVersionSummary[];
  pins: IPin[];
  selected: number;
  onSelect: (version: number) => void;
  onCompare: () => void;
  now: number;
}

export const LibraryVersions = ({
  item,
  versions,
  pins,
  selected,
  onSelect,
  onCompare,
  now,
}: IProps) => (
  <div>
    <SectionPanel
      title="Versions"
      actions={
        <Button size="sm" variant="ghost" disabled={versions.length < 2} onClick={onCompare}>
          Compare
        </Button>
      }
    >
      {versions.map((version) => {
        const holders = versionHolding(version.version, pins);
        return (
          <button
            key={version.id}
            type="button"
            onClick={() => onSelect(version.version)}
            className={cn(
              'flex w-full items-center gap-inset border-b border-border-row px-3 py-2 text-left',
              version.version === selected ? 'bg-hover' : 'hover:bg-hover',
            )}
          >
            <span className="w-col-try shrink-0 font-mono text-data text-primary">
              v{version.version}
            </span>
            <span className="min-w-0 truncate text-meta text-muted">
              {versionNote(version, item.latestVersion, pins)}
            </span>
            <span className="ml-auto shrink-0 font-mono text-micro text-faint">
              {holders.length > 0 ? holdersWords(holders) : relativeTime(version.createdAt, now)}
            </span>
          </button>
        );
      })}
    </SectionPanel>
  </div>
);
